var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaxiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 173,
    viewBox: "0 0 210 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 132.391,
    rx: 20,
    fill: "#F4C70E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 132H80L54.9444 156.296L39 173V132Z",
    fill: "#F4C70E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50.2175,
    y: 27.3911,
    width: 36.5217,
    height: 36.5217,
    rx: 2.73171,
    fill: "#313A43"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6956,
    y: 63.9131,
    width: 36.5217,
    height: 36.5217,
    rx: 2.73171,
    fill: "#313A43"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 86.739,
    y: 63.9131,
    width: 36.5217,
    height: 36.5217,
    rx: 2.73171,
    fill: "#313A43"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 123.261,
    y: 27.3911,
    width: 36.5217,
    height: 36.5217,
    rx: 2.73171,
    fill: "#313A43"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 159.782,
    y: 63.9131,
    width: 36.5217,
    height: 36.5217,
    rx: 2.73171,
    fill: "#313A43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxiLogo);
export default __webpack_public_path__ + "static/media/taxi-logo.3c4f1ec939214f75adf82d421acb77a6.svg";
export { ForwardRef as ReactComponent };